import React, { useState } from "react";
import { MailWarning } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useApp } from "@/store";

export const EmailVerifyBanner = () => {
  const { t, user } = useApp();
  const [busy, setBusy] = useState(false);
  if (!user || user.email_verified || user.role === "admin") return null;
  const resend = async () => {
    setBusy(true);
    try { await api.post("/auth/resend-verification"); toast.success(t("verify_resent")); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="border-b border-amber-200 bg-amber-50" data-testid="email-verify-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3 px-5 py-2.5 text-sm text-amber-900 sm:px-8">
        <MailWarning size={16} className="shrink-0" />
        <span className="flex-1">{t("verify_banner")} <b>{user.email}</b></span>
        <button data-testid="resend-verification" disabled={busy} onClick={resend} className="rounded-full bg-amber-900 px-4 py-1 text-xs font-bold text-white disabled:opacity-60">{t("verify_resend")}</button>
      </div>
    </div>
  );
};
